/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { memo } from 'react';
import { Route, RouteProps } from 'react-router-dom';
import { Spin } from '../../components/Spin';

export interface IUnAuthenticatedRouteProps extends RouteProps {
  path: string;
  component: any;
  query?: string;
  children?: React.ReactNode;
}

const UnAuthenticatedRoute: React.FC<IUnAuthenticatedRouteProps> = ({
  component: Component,
  ...props
}) => {
  const loadSuccess = true;

  const renderComponent = (): JSX.Element => {
    return <Component {...props} />;
  };

  return loadSuccess ? (
    <Route {...props} render={(): JSX.Element => renderComponent()} />
  ) : (
    <Spin spinning />
  );
};

export default memo(UnAuthenticatedRoute);
